import { render } from "./BistroBadge.vue?vue&type=template&id=1998fe2e"
import script from "./BistroBadge.vue?vue&type=script&lang=js"
export * from "./BistroBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__